export const PaymentStatusLabel = {
  0: 'Pagado',
  1: 'Incompleto',
  2: 'Sin pagar',
}
